module.exports = __webpack_public_path__ + "img/多益專區.016dddcb.png";